const locale = typeof window === "undefined" ? "en" : (window.navigator.languages[0] ?? "en");
export const browserTimeZones = Intl.supportedValuesOf("timeZone");
export const defaultTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
export const listFormatConjunction = (array: string[]) =>
  new Intl.ListFormat(locale, { style: "long", type: "conjunction" }).format(array);
